import { useContext } from 'react'
import { schema } from 'prose-core'
import { NodeSelection } from 'prosemirror-state'

import { upsertMark } from 'common/Prose/Commands/marks'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import {
  WeightName,
  WeightValuesMap,
} from 'common/Prose/Toolbar/components/Format/components/MainStylePane/components/FontWeight/util'

export function useFontWeight() {
  const view = useEditorView()
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { activeFamilies, activeWeights } = useContext(AlmanacEditorStateContext)!

  const setFontWeight = (newWeightName: WeightName) => {
    const {
      state,
      state: { selection, tr },
      dispatch,
    } = view
    const weightValue = WeightValuesMap[newWeightName]

    if (selection instanceof NodeSelection && 'fontWeight' in selection.node.attrs) {
      tr.setNodeMarkup(selection.from, undefined, { ...selection.node.attrs, fontWeight: weightValue })
      dispatch(tr)
      return
    } else {
      upsertMark(schema.marks.font_weight, { weight: weightValue })(state, dispatch)
    }

    view.focus()
  }

  return { setFontWeight, activeFamilies, activeWeights }
}
